import React from 'react';
import styled from '@emotion/styled';
import CrossIcon from 'assets/svg/circle-cross.svg';
import { Text } from 'ds/components/typography';
import { ToastType } from './types';


const Root = styled.div`
  ${({ theme }) => `
    border: 1px solid #FF6658;
    backdrop-filter: blur(25px);
    border: ${theme.borderRadius.large};
    background-color: #FAE8E8;
    color: ${theme.colors.neutrals.grey1};
    border-radius: ${theme.borderRadius.large};
    padding: ${theme.spacing(2, 2.5)};
  `}
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    min-width: 370px;
  `}
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    margin: ${theme.spacing(2)};
  `}
`;

const IconWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      margin-left: ${theme.spacing(1.5)};
    }
  `}
`;

interface FeedbackToastProps {
  type?: ToastType;
  children: string;
  preLineText?: boolean;
}

const Label = styled(Text)<{ preLineText?: boolean }>`
  display: flex;
  ${({ preLineText }) => preLineText ? `white-space: pre-line;` : ''}
`;

export const FeedbackError: React.FC<FeedbackToastProps> = (props) => {
  const { type, children, preLineText } = props;
  let icon: JSX.Element = null;

  switch (type) {
    case 'error-floating':
      icon = <CrossIcon />;
      break;
  }
  return (
    <Root data-auto="toast-message-wrapper">
      <Label data-auto="toast-message-text" preLineText={preLineText} weight="bold">
        {icon ? (
          <IconWrapper>
            {icon}
            {children}
          </IconWrapper>
        ) : children}
      </Label>
    </Root>
  );
};
